import TeachersAttedanceView from "components/teachersView/attedance";
import TeachersDetailView from "components/teachersView/detailInfo";
import { query, collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import ButtonLabels from "helper/constant/buttonLabels";
import CommonHeadings from "helper/constant/headings";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import { Button } from "primereact/button";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function TeacherView() {
  const navigate = useNavigate();
  const [statusButtonlabel, setStatusButtonlabel] = useState(ButtonLabels.activeLabel);
  const [teachersID, setTeachersID] = useState();
  const location = useLocation();


  // MARK: use Effect function
  useEffect(() => {
    editButtonLabel();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // MARK: Use Layout Method
  useLayoutEffect(() => {
    document.title = CommonHeadings.teacherView;
  }, []);

  const tabsData = [
    { id: 1, label: "Teacher Info" },
    { id: 2, label: "Attendance View" },
  ];

  const [activeTab, setActiveTab] = useState(tabsData[0].id);

  // tabs are active
  const handleTabClick = async (id) => {
    if (id === 1) {
      setActiveTab(id);
    } else {
      setActiveTab(id);
    }
  };

  // MARK: API
  async function fetchTeacherApi() {
    let q = query(
      collection(dbFirestore, TableName.teachers),
    );
    const querySnapshot = await getDocs(q);
    const array = querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }));
    const teacherObject = array.find(
      (teacher) => teacher.id === location.state.id
    );
    return teacherObject
  }


  async function editButtonLabel() {
    try {
      const teacherData = await fetchTeacherApi();
  
      if (!teacherData) {
        toast.error("Student data not found.");
        <ToastContainer/>
        return;
      }
  
      setTeachersID(location.state.id);
  
      if (teacherData["status"]) {
        setStatusButtonlabel(
          teacherData["status"] === "active" ? ButtonLabels.leaveLabel : ButtonLabels.activeLabel
        );
      } else {
        toast.error("Status is undefined for student.");
        <ToastContainer/>
      }
    } catch (error) {
      toast.error("Error fetching student data:", error);
      <ToastContainer/>
    }
  }

  async function updateStudentsApi() {
    const studentStatus = await fetchTeacherApi();

    await updateDoc(doc(dbFirestore, TableName.teachers, teachersID), {
      status: studentStatus["status"] === "active" ? "leave" : "active",
    });
  }

  const tapOnStatusButton = () => {
    Swal.fire({
      title: "Are you sure?",
      text: location.state.status === "active" ? `You want to marked it as "Leave"` : `You want to marked it as "Active"`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        updateStudentsApi()
        navigate(RoutingPaths.teachersList)
      }
    });
  };

  const Tabs = () => {
    return (
      <>
        <div style={{ marginBottom: "1rem" }}>
          <Button icon="pi pi-arrow-left"
            type="button"
            onClick={() => navigate(-1)}
            className="view__back_button me-3"
          />
        </div>
        <div className="search__main_div" style={{ paddingLeft: "2rem" }}>
          <div className="tabs" style={{ flexGrow: "1" }}>
            {tabsData.map((tab) => (
              <button
                key={tab.id}
                className={`tab-button tab-buttons ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

        </div>
      </>
    );
  };

  const header = Tabs();

  return (
    <>
      <div className="modules__main__div">
        <div className="col-12">
          <div className="card modules__card">
            {header}

            {activeTab === tabsData[0].id ? <TeachersDetailView /> : <TeachersAttedanceView />}

            {activeTab === tabsData[0].id &&  <div className="mb-5">
              <Button label={statusButtonlabel} type="button" onClick={tapOnStatusButton} className="view__student_status_button" />
            </div>}
          </div>
        </div>
      </div>
    </>
  )
}

export default TeacherView;
